<template>
  <i18n-t class="paragraph-content" :keypath="keypath" tag="div">
    <template #br>
      <br>
    </template>
    <template #bold>
      <span class="bold">{{ boldText }}</span>
    </template>
    <template #sendername>
      <strong>{{ sendername }}</strong>
    </template>
    <template #email>
      <span><strong>{{ email }}</strong></span>
    </template>
    <template #link_to_store>
      <a :href="ProductType.Store.url" @click.prevent="onNavigateTo(ProductType.Store)">{{ $t(`product.store.title`) }}</a>
    </template>
    <template #link_to_web>
      <a :href="ProductType.Web.url" @click.prevent="onNavigateTo(ProductType.Web)">{{ $t(`product.web.title`) }}</a>
    </template>
    <template #contact_us>
      <a :href="`mailto:${config.supportEmail}`" target="/">{{ $t(`common.link.contact_us`) }}</a>
    </template>
  </i18n-t>
</template>

<script setup>
import { useEnvironment, useAnalytics, useProduct } from 'ihunter-pathfinder-components';
import { useRouteManager } from '../composables/useRouteManager';

const { config } = useEnvironment();
const { redirectToWebOrLogin } = useRouteManager();
const { logNavigatedTo } = useAnalytics();
const { ProductType } = useProduct();

const props = defineProps({
  keypath: {
    type: String,
    required: true
  },
  email: {
    type: String,
    required: false,
    default: ''
  },
  sendername: {
    type: String,
    required: false,
    default: ''
  },
  boldText: {
    type: String,
    required: false,
    default: ''
  }
});

const onNavigateTo = (product) => {
  logNavigatedTo(product.name);
  if (product === ProductType.Web) {
    redirectToWebOrLogin();
  } else {
    window.open(product.url);
  }
}
</script>
<style lang="scss" scoped>
@use '../styles/Accounts' as Accounts;

@include Accounts.Default;
</style>